













import { Component, Vue } from 'vue-property-decorator';
import { IFilter, SearchType } from '../Scripts/ISearchService';
import { FacetMetadata } from '../Scripts/FacetMetadata';
import { FilterHelper } from '../Scripts/FilterHelper';

@Component
export default class SearchSummary extends Vue {
	get query (): string {
		return this.$store.state.submittedQuery;
	}

	get filters (): IFilter[] {
		const filters = this.$store.state.filters as IFilter[];
		return filters.filter((f) => f.removable);
	}

	get staticFilters (): IFilter[] {
		const filters = this.$store.state.filters as IFilter[];

		return filters.filter((f) => !f.removable);
	}

	get queryNoMatches (): boolean {
		return this.$store.state.queryNoMatch;
	}

	get facetsToShow (): boolean {
		return true;
		// return this.filters.length > 0 || (!!this.query && !this.queryNoMatches);
	}

	get resultType (): SearchType {
		return this.$store.state.searchType;
	}

	public async clearKeywords (): Promise<void> {
		const helper = new FilterHelper(this.$router);

		helper.clearKeywords();
	}

	public async clearFilter (filter: IFilter): Promise<void> {
		const metadata = FacetMetadata.list(this.resultType).find((m) => m.column === filter.key);
		const key = metadata ? metadata.query : filter.key;

		const helper = new FilterHelper(this.$router);
		helper.clearFilter(key);
	}
}
